/** Dimensiones del compás melody (deben coincidir con las variables CSS). */
export function melodyMeasureDimensions(cellSizePx: number, rootRemPx: number) {
  const cellGap = 4;
  const beatMinWidth = 4 * cellSizePx + 3 * cellGap + 12;
  const measureWidth = 2 * beatMinWidth + 0.4 * rootRemPx + 1.1 * rootRemPx;

  const beatHeader = 54;
  const beatCells = cellSizePx + 22;
  const beatRow = beatHeader + beatCells;
  const beatsGap = 0.4 * rootRemPx;
  const labelBlock = 30 + 0.55 * rootRemPx;
  const measurePadding = (0.6 + 0.5) * rootRemPx;
  const measureHeight = measurePadding + labelBlock + 2 * beatRow + beatsGap;

  return { measureWidth, measureHeight };
}

export function readMelodyCellSizePx(appEl: HTMLElement | null): number {
  if (!appEl) return 46;
  const raw = getComputedStyle(appEl).getPropertyValue('--melody-cell-size').trim();
  return parseFloat(raw) || 46;
}

export interface MelodyPlayGrid {
  cols: number;
  rows: number;
  visible: number;
  shift: number;
}

const GRID_GAP_X = 12;
const GRID_GAP_Y = 12;

/** Cuántos compases caben a tamaño completo en el viewport de reproducción. */
export function computeMelodyPlayGrid(
  availWidth: number,
  availHeight: number,
  measureWidth: number,
  measureHeight: number,
  measureCount: number,
): MelodyPlayGrid {
  const maxCols = Math.max(
    1,
    Math.floor((availWidth + GRID_GAP_X) / (measureWidth + GRID_GAP_X)),
  );
  const maxRows = Math.max(
    1,
    Math.floor((availHeight + GRID_GAP_Y) / (measureHeight + GRID_GAP_Y)),
  );

  let best: MelodyPlayGrid = { cols: 1, rows: 1, visible: 1, shift: 1 };

  for (let cols = 1; cols <= maxCols; cols++) {
    for (let rows = 1; rows <= maxRows; rows++) {
      const capacity = cols * rows;
      const visible = Math.min(capacity, measureCount);
      const candidate: MelodyPlayGrid = {
        cols,
        rows,
        visible,
        shift: Math.max(1, Math.ceil(visible / 2)),
      };

      if (candidate.visible > best.visible) {
        best = candidate;
      } else if (
        candidate.visible === best.visible &&
        (candidate.cols > best.cols ||
          (candidate.cols === best.cols && candidate.rows < best.rows))
      ) {
        best = candidate;
      }
    }
  }

  return best;
}

const MELODY_CANVAS_GAP_X = 12;

/** Tamaño máximo de celda para que quepan `measureCount` compases en el viewport. */
export function computeMelodyCellSizeForMeasures(
  availWidth: number,
  availHeight: number,
  measureCount: number,
): number {
  if (availWidth <= 0 || availHeight <= 0) return 46;

  const rootRem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
  let best = 40;

  for (let cell = 40; cell <= 128; cell += 1) {
    const { measureWidth, measureHeight } = melodyMeasureDimensions(cell, rootRem);
    const totalW =
      measureCount * measureWidth + Math.max(0, measureCount - 1) * MELODY_CANVAS_GAP_X;
    if (totalW <= availWidth && measureHeight <= availHeight) {
      best = cell;
    }
  }

  return best;
}
